module.exports = __WEBPACK_EXTERNAL_MODULE__2884__;